<template>
  <div class="recommend-works-box">
    <div @click="clickImage(item.id)" class="works-box-top flex-row">
      <van-image style="pointer-events:none;" width="175" height="120" :src="item.coverUrl+'?x-oss-process=image/resize,l_750'" fit="cover" />
    </div>
    <div class="works-info">
      <div class="spec-name nowrap">{{ item.title }}</div>
      <div v-if="item.user" class="spec-post nowrap">{{ item.user?.nickname }}</div>
    </div>
  </div>
</template>

<script>
// import { ImagePreview } from 'vant'
export default {
  name: 'WorkS',
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    // 画作数组
    workerList () {
      return this.image.map((v) => v.coverUrl)
    }
  },
  methods: {
    // 点击画作
    clickImage (id) {
      this.$emit('prioimg', id)
    }
  }
}
</script>

<style lang="scss" scoped>
.recommend-works-box:not(:nth-last-child(-1n+2)) {
  margin-bottom: 25px;
}
.recommend-works-box {
  width:160px;
  box-sizing: border-box;
  border-radius: 2px;
  background-color: #ffffff;
  .works-box-top {
    margin-bottom: 10px;
    width: 100%;
    justify-content: space-between;
    position: relative;

    .works-pic {
      width: 120px;
      height: 120px;
      border-radius: 4px;
    }

    .works-next {
      position: absolute;
      bottom: 4px;
      right: 4px;
      width: 50px;
      height: 26px;
      background: #891e07;
      border-radius: 27px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      align-items: center;
      justify-content: center;
    }
  }
.works-info {
.spec-name {
    font-size: 15px;
    font-family: PingFang-SC-Medium;
    color: #333333;
    margin-bottom: 10px;
    line-height: 1.5;
    display: inline-block;
    box-sizing: border-box;
    /* 超出部分使用省略号 */
    text-overflow: -o-ellipsis-lastline;
    /* 超出部分隐藏 */
    overflow: hidden;
    /* 超出部分使用省略号 */
    text-overflow: ellipsis;
    /* 设置布局 */
    display: -webkit-box;
    /* 控制显示 */
    -webkit-line-clamp: 2;
    /* 控制显示行数 */
    line-clamp: 2;
    -webkit-box-orient: vertical;
    /* 设置英文，数字不换行 */
    word-break: break-all;
    white-space: normal;
  }

  .spec-post {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #727272;
    line-height: 1;
    box-sizing: border-box;
  }
}

}
</style>
